"use client";

import { useState } from "react";
import InputField from "../ui/InputField";
import Button from "../ui/buttons";

export default function EditProfileForm() {
  const [name, setName] = useState("Dinamani");
  const [email, setEmail] = useState("dinamani@gmail.com");
  const [mobile, setMobile] = useState("9999999999");
  const [optionalMobile, setOptionalMobile] = useState("Rather not specify");

  return (
    <div className="w-full flex flex-col items-center gap-4 py-24">
      <h3 className="text-24-tamil-700 text-020202 text-center">
          சுயவிவரத்தைத் திருத்து
        </h3>
    <div className="mx-auto p-6 bg-FFFFFF w-full max-w-4xl lg:max-w-6xl xl:w-[648px] xl:h-[558px]">
      
      <div className="flex flex-col gap-5">
       
        {/* Row 1: Name */}
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="sm:flex-1">
            <label className="block mb-2 text-222222 text-12-tamil-500">Name</label>
            <InputField
              placeholder="Enter your name"
              value={name}
              onChange={setName}
              height="61px"
            />
          </div>
        </div>

        {/* Row 2: Email */}
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="sm:flex-1">
            <label className="block mb-2 text-222222 text-12-tamil-500">Email</label>
            <InputField
              placeholder="Enter your email"
              value={email}
              onChange={setEmail}
              height="61px"
            />
          </div>
        </div>

        {/* Row 3: Mobile Number */}
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="sm:flex-1">
            <label className="block mb-2 text-222222 text-12-tamil-500">Mobile Number</label>
            <InputField
              placeholder="Enter your mobile number"
              value={mobile}
              onChange={setMobile}
              height="61px"
            />
          </div>
        </div>

        {/* Row 4: Optional Mobile Number */}
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="sm:flex-1">
            <label className="block mb-2 text-222222 text-12-tamil-500">Optional Mobile Number</label>
            <InputField
              placeholder="Rather not specify"
              value={optionalMobile}
              onChange={setOptionalMobile}
              height="61px"
            />
          </div>
        </div>

        {/* Submit button */}
        <div className="mt-4 sm:mt-6">
          <Button variant="primary" onClick={() => {}} className="w-full text-18-tamil-700 cursor-pointer">Save Details</Button>
        </div>
      </div>
    </div>
    </div>
  );
}
